module.exports = __webpack_public_path__ + "media/images/Vectoryellow-b59d39d5.png";